var map = {
	"./template.bet575": 1079,
	"./template.bet575.tsx": 1079,
	"./template.bet777": 2133,
	"./template.bet777.tsx": 2133,
	"./template.betstride": 2134,
	"./template.betstride.tsx": 2134,
	"./template.buffalobet": 2135,
	"./template.buffalobet.tsx": 2135,
	"./template.chromabet": 1080,
	"./template.chromabet.tsx": 1080,
	"./template.default": 124,
	"./template.default.tsx": 124,
	"./template.epicodds": 2136,
	"./template.epicodds.tsx": 2136,
	"./template.forsport": 1081,
	"./template.forsport.tsx": 1081,
	"./template.gigabet": 2137,
	"./template.gigabet.tsx": 2137,
	"./template.goldenbet888": 2138,
	"./template.goldenbet888.tsx": 2138,
	"./template.goldenrush": 2139,
	"./template.goldenrush.tsx": 2139,
	"./template.hyperbet": 1082,
	"./template.hyperbet.tsx": 1082,
	"./template.juicybet": 2140,
	"./template.juicybet.tsx": 2140,
	"./template.junglebet": 2141,
	"./template.junglebet.tsx": 2141,
	"./template.magnumbet": 1083,
	"./template.magnumbet.tsx": 1083,
	"./template.oldgill": 1084,
	"./template.oldgill.tsx": 1084,
	"./template.puntcity": 2029,
	"./template.puntcity.tsx": 2029,
	"./template.pyramidbet": 1085,
	"./template.pyramidbet.tsx": 1085,
	"./template.slambet": 2142,
	"./template.slambet.tsx": 2142,
	"./template.sterlingparker": 2143,
	"./template.sterlingparker.tsx": 2143,
	"./template.templebet": 2030,
	"./template.templebet.tsx": 2030,
	"./template.titanbet": 2144,
	"./template.titanbet.tsx": 2144,
	"./template.ts": 968,
	"./template.vikingbet": 2145,
	"./template.vikingbet.tsx": 2145
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2423;